import { useCallback, useEffect, useState } from "react";
import { api } from "../api";
import { useAuth } from "../AuthContext";

export default function History() {
  const { user } = useAuth();
  const [history, setHistory] = useState([]);

  const load = useCallback(async () => {
    const { data } = await api.get("/history");
    setHistory(data.history || []);
  }, []);

  useEffect(() => { load(); }, [load]);

  async function del(id) {
    if (!confirm("Delete this upload?")) return;
    await api.delete(`/history/${id}`);
    load();
  }

  const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
  const token = localStorage.getItem("vsdi_token");
  const download = (id) => {
    fetch(`${API}/history/${id}/download`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => r.blob())
      .then((b) => {
        const url = URL.createObjectURL(b);
        const a = document.createElement("a");
        a.href = url; a.download = `vSDI_billability_${id}.csv`; a.click();
        URL.revokeObjectURL(url);
      });
  };

  return (
    <div data-testid="history-page">
      <h2 className="text-xl font-bold mb-4" style={{ color: "#1a3666" }}>Upload History ({history.length})</h2>
      <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-500 text-[11px] uppercase">
            <tr>
              <th className="px-3 py-2 text-left">Filename</th>
              <th className="px-3 py-2 text-left">Uploaded</th>
              <th className="px-3 py-2 text-left">By</th>
              <th className="px-3 py-2 text-center">Period</th>
              <th className="px-3 py-2 text-center">Records</th>
              <th className="px-3 py-2 text-center">Projects</th>
              <th className="px-3 py-2 text-center">Streams</th>
              <th className="px-3 py-2 text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {history.map((h) => (
              <tr key={h.id} className="border-t border-slate-100 hover:bg-slate-50" data-testid="history-row">
                <td className="px-3 py-2 font-medium">{h.filename}</td>
                <td className="px-3 py-2 text-xs">{new Date(h.uploaded_at).toLocaleString()}</td>
                <td className="px-3 py-2 text-xs">{h.by_name || h.by_email || "—"}</td>
                <td className="px-3 py-2 text-center text-xs">{h.period}</td>
                <td className="px-3 py-2 text-center">{h.record_count}</td>
                <td className="px-3 py-2 text-center">{h.project_count}</td>
                <td className="px-3 py-2 text-center">{h.stream_count}</td>
                <td className="px-3 py-2 text-center space-x-2">
                  <button onClick={() => download(h.id)} className="text-blue-600 hover:underline text-xs" data-testid={`hist-dl-${h.id}`}>Download</button>
                  {user?.role === "admin" && (
                    <button onClick={() => del(h.id)} className="text-red-600 hover:underline text-xs" data-testid={`hist-del-${h.id}`}>Delete</button>
                  )}
                </td>
              </tr>
            ))}
            {!history.length && <tr><td colSpan={8} className="px-3 py-8 text-center text-slate-400">No uploads yet</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
